import React, { useMemo } from "react";
import { Col, Row } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import ContentTabs from "@repoflow/components/content-tabs";
import { useSectionContext } from "@repoflow/components/section";
import { usePreview } from "@repoflow/components/preview";
import * as widgets from "widgets/register";
import { TemplateLink } from "../../../blog";
import * as ConfigRoute from "../../config";

// Hoisted, for the reason every editor screen gives: an inline config literal
// is a new object per render and the form rebuilds under it.
const FORM_CONFIG = {
  "/Page/Element/Type/BlogList": {
    fields: ["limit", "tag", "postRoute"],
  },
};

// THE LISTING. Page size, a tag to narrow to, and the route of the page that
// shows one post (for the links). The page NUMBER is the route's —
// `/blog/:page?` — and the Editor tab's `page` param previews one. The
// template is the site's, on the blog's Templates tab.
const Listing = () => {
  const { schema, state, attributes } = useSectionContext();
  const preview = usePreview();
  const { values, setValues } = state;
  const config = values.config || {};

  return (
    <Row>
      <Col>
        <p className="text-muted">
          The page number is the route's: put this element on a page whose route
          is <code>/blog/page/:page?</code>. Not <code>/blog/:page?</code> beside
          a <code>/blog/:slug</code> post page — the two cannot be told apart.
        </p>
        <Form
          schema={schema}
          target={{ $ref: "/Page/Element/Type/BlogList" }}
          widgets={widgets}
          values={config}
          onChange={(mod) => {
            setValues({ ...values, config: mod });
            preview.refresh();
          }}
          config={FORM_CONFIG}
        />
        <TemplateLink siteId={attributes.siteId} kind="list" />
      </Col>
    </Row>
  );
};

export const Content = () => {
  const tabs = useMemo(
    () => [
      { label: "List", content: <Listing /> },
      { label: "Element", content: <ConfigRoute.Content /> },
    ],
    []
  );

  return <ContentTabs tabs={tabs} />;
};
